<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				
				<FormItem label="类型" prop="type" class="sj">
					<Select v-model="formValidate.type" placeholder="请选择类型">
						<Option value="1">轮播图</Option>
						<Option value="2">短视频</Option>
					</Select>
				</FormItem>
				<FormItem label="备注" prop="remark" class="sj">
					<Input v-model="formValidate.remark" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem v-if="formValidate.type=='1'">
					<Imgs @imgFile="imgFile" number="5" url="/file/img/adv"></Imgs>
				</FormItem>
				<FormItem v-else>
					<File  @file="file" url="/file/video/adv"></File>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Imgs from '@/components/comm/imgs.vue'
	import File from '@/components/comm/file.vue'
	export default {
		data() {
			return {
				formValidate: {
					type: '1',
					remark: '',
					imgs:'',
					video:'',
					spomsorId:''
				},
				ruleValidate: {
					type: [{
						required: true,
						message: '类型不能为空！！！',
						trigger: 'blur'
					}],
					remark: [{
						required: true,
						message: '备注不能为空！！！',
						trigger: 'blur'
					}]
					

				}

			}
		},
		components: {
			Imgs,File
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						if(this.formValidate.type=='1'){
							if(this.formValidate.imgs==''){
								this.$Message.error('请先上传图片!');
								return ;
							}
						}
						if(this.formValidate.type=='2'){
							if(this.formValidate.video==''){
								this.$Message.error('请先上传视频!');
								return ;
							}
						}
						this.$http.post(http.url+'/plat/platAdvSponsor/material/add', this.formValidate).then(res => {
							let data = res.data
							switch (data.code) {
								case 200:
									this.$Message.success('新增成功!');
									break;

								case 1000:
									this.$Message.error('登陆失效，请重新登陆!');
									setTimeout(function() {
										this.$router.push('/login')
									}, 1000);
									break;
								case 100:
									this.$Message.error('服务器异常!');
									break;
								case 101:
									this.$Message.error(data.error);
									break;
								default:
									this.$Message.error('服务器异常!');
									break;
							}

						}, res => {
							this.$Message.error('系统异常请刷新后重试!');
						})

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			imgFile(urls){
				this.formValidate.imgs=urls
			},
			file(video){
				this.formValidate.video=video.name
			}
			
		},
		created() {
			let spomsorId=this.$route.query.spomsorId
			this.formValidate.spomsorId=spomsorId
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/meaterial/add.vue